import { NODE_LABELS } from '@atbash-labs/ontology-core'

/**
 * Eager per-label entity counts for the Model browser rail.
 *
 * One UNION ALL arm per published {@link NODE_LABELS} entry — each arm is an
 * indexed label scan (`MATCH (n:\`Label\`)`), the same shape
 * {@link plantLabelEntitiesCypher} and {@link PLANT_STRAY_COUNTS_CYPHER} use.
 *
 * Do NOT use `labels(n)[0]`. Every node also carries the `_Entity` identity
 * label, and after a SET/REMOVE relabel Neo4j may surface `_Entity` first,
 * which would make the sidebar show 0 while `MATCH (n:ThatLabel)` still
 * finds the nodes.
 */
function buildLabelCountsCypher(): string {
  const arms = [...NODE_LABELS].sort().map(
    (label) => `
      MATCH (n:\`${label}\`)
      WHERE n.id IS NOT NULL
      RETURN '${label}' AS label, count(n) AS total`
  )
  if (arms.length === 0) {
    return `RETURN '' AS label, 0 AS total LIMIT 0`
  }
  return arms.join('\n    UNION ALL\n')
}

export const PLANT_LABEL_COUNTS_CYPHER = buildLabelCountsCypher()
